/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable radix */
/* eslint-disable no-sequences */
import departmentData from "cms/department-data";
import { useEffect, useMemo, useState } from "react";
import useIsDesktop from "hooks/useIsDesktop";
import AddEditContentModal from "components/Job/AddEditContentModal";
import NoSearchIconJobFilters from "assets/svgs/NoSearchIconJobFilters";
import clsx from "clsx";
import { useRouter } from "next/router";
import { numberWithCommas } from "modules/candidate/profile/utils/parsers";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import {
	MIN_EXPERIENCE_DEFAULT_VALUE,
	VALUE_TO_LABEL_MAPPING,
} from "components/RevampFeedDetails/constants";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { JOBS_PER_PAGE } from "utils/constants";
import {
	CustomSlider,
	CustomValueLabel,
} from "components/RevampFeedDetails/JobFeed/components/DesktopFilters";
import { isOnboardingComplete, isUserLoggedIn } from "utils";
import { getKeyByValue, SALARY_SCALE } from "constants/filters";
import SelectChipsContainer from "../SelectChipsContainer/index";
import {
	ApplyButton,
	Choice,
	ChoicesContainer,
	ClearButton,
	FiltersContainer,
	Footer,
	FooterContainer,
	MobileContainer,
	OptionsContainer,
} from "./styles";
import SearchBar from "../SearchBar";
import CheckboxInput from "../Checkbox";
import InputSlider from "../InputSlider";
import { Drawer, makeStyles } from "@material-ui/core";
import CrossWithBGIcon from "components/RevampFeedDetails/assets/CrossWithBGIcon";

export const POSTED_IN_OPTIONS = [
	{ label: "All", value: -1 },
	{ label: "Last 24 hours", value: 24 },
	{ label: "Last 3 days", value: 24 * 3 },
	{ label: "Last 7 days", value: 24 * 7 },
];

export const DISTANCE_OPTIONS = [
	{ label: "All", value: "" },
	{ label: "Within 5 km", value: "lt-5" },
	{ label: "Within 10 km", value: "lt-10" },
	{ label: "Within 20 km", value: "lt-20" },
	{ label: "Within 50 km", value: "lt-50" },
];

export const EDUCATION_OPTIONS = [
	{ label: "10 or Below 10th", value: 1 },
	{ label: "12th Pass", value: 2 },
	{ label: "Diploma", value: 3 },
	{ label: "ITI", value: 4 },
	{ label: "Graduate", value: 5 },
	{ label: "Post Graduate", value: 6 },
];

const WORK_MODE_OPTIONS = [
	{ label: "Work from home", value: "wfh" },
	{ label: "Work from office", value: "wfo" },
	{ label: "Work from field", value: "wff" },
];

const WORK_TYPE_OPTIONS = [
	{ label: "Full time", value: "full_time" },
	{ label: "Part time", value: "part_time" },
	{ label: "Internship", value: "internship" },
];

const WORK_SHIFT_OPTIONS = [
	{ label: "Day shift", value: "day_shift" },
	{ label: "Night shift", value: "night_shift" },
];

const SORT_BY_OPTIONS = [
	{ label: "Relevant", value: "" },
	{ label: "Date posted - New to Old", value: "-last_updated" },
	{ label: "Salary - High to low", value: "-max_salary" },
	{ label: "Distance - Near to far", value: "-max_distance" },
];

const JOB_TYPES_OPTIONS = [
	{ label: "Work From Home", value: "workFromHome" },
	{ label: "Part Time", value: "partTime" },
	{ label: "Night Shift", value: "nightShift" },
	{ label: "Jobs For Women", value: "womenJobs" },
	{ label: "Jobs For Freshers", value: "freshersJobs" },
];

export const GENDER_OPTIONS = [
	{ label: "Female", value: "gender-f" },
	{ label: "Male", value: "gender-m" },
	// { label: "Other", value: "gender-o" },
];
export const ENGLISH_LEVEL_OPTIONS = [
	{ label: "No English", value: "No English" },
	{ label: "Basic English", value: "Basic English" },
	{ label: "Intermediate English", value: "Intermediate English" },
	{ label: "Advanced English", value: "Advanced English" },
];

export const getSelectedFiltersList = (filterStates) => {
	const selectedFilters = [];

	if (filterStates?.education_level) {
		const level = EDUCATION_OPTIONS?.find(
			(obj) => obj.value === filterStates?.education_level
		);
		selectedFilters.push({ education: level?.label });
	}
	if (
		Array.isArray(filterStates?.department_id) &&
		filterStates?.department_id?.length
	) {
		const arrayList = filterStates?.department_id.map((obj) => obj.name);
		selectedFilters.push({ department: arrayList });
	}
	if (Array.isArray(filterStates?.work_mode) && filterStates?.work_mode?.length) {
		selectedFilters.push({ workMode: filterStates?.work_mode });
	}
	if (Array.isArray(filterStates?.work_type) && filterStates?.work_type?.length) {
		selectedFilters.push({
			workType: filterStates?.work_type?.length ? filterStates?.work_type : null,
		});
	}
	if (Array.isArray(filterStates?.work_shift) && filterStates?.work_shift?.length) {
		selectedFilters.push({ workShift: filterStates?.work_shift });
	}
	if (filterStates?.sort_by) {
		selectedFilters.push({ sortBy: filterStates?.sort_by });
	}
	if (filterStates?.distance) {
		selectedFilters.push({
			distance: filterStates?.distance,
		});
	}
	if (filterStates?.posted_in) {
		const posted = POSTED_IN_OPTIONS?.find(
			(obj) => obj.value === filterStates?.posted_in
		);
		selectedFilters.push({ postedIn: posted?.label });
	}
	if (filterStates?.min_experience && filterStates?.min_experience !== 32) {
		selectedFilters.push({ experience: filterStates?.min_experience });
	}
	if (filterStates?.salary) {
		selectedFilters.push({ salary: filterStates?.salary });
	}
	if (filterStates?.gender) {
		selectedFilters.push({
			others: filterStates?.gender ? filterStates?.gender : null,
		});
	}
	return selectedFilters;
};

export enum FilterChoice {
	DEPARTMENT = "department",
	SALARY = "salary",
	EXPERIENCE = "experience",
	EDUCATION = "education",
	WORK_MODE = "work_mode",
	WORK_TYPE = "work_type",
	WORK_SHIFT = "work_shift",
	POSTED_IN = "posted_in",
	SORT_BY = "sort_by",
	GENDER = "gender",
	ENGLISH = "english_level",
	DISTANCE = "distance",
	FEATURED = "featured",
}

// Filter labels for job search page
export const FILTER_LABELS = {
	[FilterChoice.EXPERIENCE]: "Experience",
	[FilterChoice.POSTED_IN]: "Date posted",
	[FilterChoice.DISTANCE]: "Distance",
	[FilterChoice.SALARY]: "Salary",
	[FilterChoice.EDUCATION]: "Education",
	[FilterChoice.WORK_MODE]: "Work mode",
	[FilterChoice.WORK_TYPE]: "Work type",
	[FilterChoice.WORK_SHIFT]: "Work shift",
	[FilterChoice.DEPARTMENT]: "Department",
	[FilterChoice.ENGLISH]: "English level",
	[FilterChoice.GENDER]: "Gender",
	[FilterChoice.SORT_BY]: "Sort by",
	[FilterChoice.FEATURED]: "One-Click Filters",
};

// Filter labels for job feed page
export const FILTER_LABELS_FEED = {
	[FilterChoice.POSTED_IN]: "Date posted",
	[FilterChoice.DISTANCE]: "Distance",
	[FilterChoice.SALARY]: "Salary",
	[FilterChoice.WORK_MODE]: "Work mode",
	[FilterChoice.WORK_TYPE]: "Work type",
	[FilterChoice.WORK_SHIFT]: "Work shift",
	[FilterChoice.DEPARTMENT]: "Department",
	[FilterChoice.SORT_BY]: "Sort by",
	[FilterChoice.FEATURED]: "One-Click Filters",
};

const initialFilterStates = {
	department_id: [],
	salary: "",
	min_experience: MIN_EXPERIENCE_DEFAULT_VALUE,
	work_mode: [],
	work_type: [],
	work_shift: [],
	posted_in: -1,
	sort_by: "",
	page: 1,
	page_size: JOBS_PER_PAGE,
	education_level: null,
	gender: "",
	english_level: "",
	distance: "",
	featured_jobs: false,
};

type FiltersidebarPropsType = {
	closeSidebar: () => void;
	activeFilterState?: FilterChoice;
	isShowFilterSidebar?: boolean;
	departmentObject?: [];
};

const EmptySearchView = ({ searchSource, isDesktopView }) => (
	<div className="flex rounded bg-[#F9F8FA] p-3">
		<div className="mr-3 pt-1">
			<NoSearchIconJobFilters />
		</div>
		<div>
			<div
				className={clsx("font-semibold text-[#8C8594]", {
					"text-[14px] leading-[20px]": isDesktopView,
					"text-[12px] leading-[16px]": !isDesktopView,
				})}
			>
				No {searchSource} found
			</div>
			<div
				className={clsx("font-normal text-[#827485]", {
					"text-[14px] leading-[20px]": isDesktopView,
					"text-[12px] leading-[16px]": !isDesktopView,
				})}
			>
				Sorry, no relevant {searchSource}s available for your search query
			</div>
		</div>
	</div>
);
const useStyles = makeStyles({
	drawer: {
		padding: 1,
		background: "transparent",
		boxShadow: "none",
		maxHeight: "700px",
	},
});
const FiltersSidebar: React.FC<FiltersidebarPropsType> = ({
	closeSidebar,
	activeFilterState,
	isShowFilterSidebar = false,
	departmentObject,
}) => {
	const {
		jobsCount,
		appliedFiltersCount,
		filters: appliedFilters,
		urlDataObject,
		applyMobileFilters,
		setExperienceSearchObject,
		setUrlSearchQuery,
		resetFiltersLocalState,
		discoveryTabs,
		clearAllFilters,
	} = useJobFeedStore();
	const classes = useStyles();
	const router = useRouter();
	const isSearch = router?.query?.search;
	const showFeaturedFilter = router.query.featured_jobs === "true";

	const FILTER_LABELS_LIST = isSearch ? FILTER_LABELS : FILTER_LABELS_FEED;

	const [activeFilterChoice, setActiveFilterChoice] = useState<FilterChoice>(
		activeFilterState || FilterChoice.SORT_BY
	);

	useEffect(() => {
		if (discoveryTabs?.activeTabId === 2) {
			setActiveFilterChoice(FilterChoice.POSTED_IN);
		} else {
			setActiveFilterChoice(FilterChoice.SORT_BY);
		}
	}, [discoveryTabs?.activeTabId]);

	/*
		Filters local state to determine filter selection and deselection 
		before user applied them with CTA click. 
		They are always in sync with filters object in store when component is mounted.
	*/
	const [filtersState, setFiltersState] = useState({
		department_id: [],
		salary: "",
		min_experience: MIN_EXPERIENCE_DEFAULT_VALUE,
		work_mode: [],
		work_type: [],
		work_shift: [],
		posted_in: -1,
		sort_by: "",
		page: 1,
		page_size: JOBS_PER_PAGE,
		education_level: null,
		gender: "",
		english_level: "",
		distance: "",
		featured_jobs: false,
	});
	const [salarySliderValue, setSalarySliderValue] = useState(0);
	const [clearTabsAppliedFilters, setClearTabsAppliedFilters] = useState(false);
	/*
		Update the local state of filters with filters object in store
		to reflect currently applied filters
	*/
	useEffect(() => {
		setFiltersState(appliedFilters);
	}, [appliedFilters]);

	useEffect(() => {
		setSalarySliderValue(0);
	}, [resetFiltersLocalState]);

	useEffect(() => {
		setSalarySliderValue(getKeyByValue(SALARY_SCALE, Number(appliedFilters?.salary)));
	}, [appliedFilters]);

	const [searchQuery, setSearchQuery] = useState<string>();
	const isDesktopView = useIsDesktop();
	const [filterWithNoRelevantSearch, setFilterWithNoRelevantSearch] = useState("");
	const [optionClickedMPEventObj, setOptionClickedMPEventObj] = useState(null);

	useEffect(() => {
		if (filterWithNoRelevantSearch && searchQuery) {
			trackOnMixpanel("Job Filter Panel Filter Not Found Web", {
				"Filter Name": filterWithNoRelevantSearch,
				"Search Query": searchQuery,
			});
		}
	}, [filterWithNoRelevantSearch, searchQuery]);

	useEffect(() => {
		/**
		 * If user changes the filter type, or we close the filter sidebar
		 * we need to reset the search field.
		 */
		if (searchQuery !== "") {
			setSearchQuery("");
		}
		if (!isShowFilterSidebar) {
			setSearchQuery("");
		}
	}, [activeFilterChoice, isShowFilterSidebar, setSearchQuery]);

	useEffect(() => {
		if (activeFilterState !== activeFilterChoice) {
			setActiveFilterChoice(activeFilterState);
		}
	}, [activeFilterState]);

	const filterDepartments = (departments, departmentQuery) => {
		if (!departmentQuery) {
			return departments;
		}

		return departments.filter((department) => {
			const departmentName = department.name.toLowerCase();
			return departmentName.includes(departmentQuery.toLowerCase());
		});
	};

	const onChangeEducation = (e: React.ChangeEvent<HTMLInputElement>) => {
		const educationLevel = parseInt(e?.target?.value, 10);
		const level = EDUCATION_OPTIONS.find((obj) => obj.value === educationLevel);

		setOptionClickedMPEventObj({
			"Filter Name": "education",
			"Option clicked": level?.label,
			"Option choice": "added",
		});
		setFiltersState((prev) => ({ ...prev, education_level: educationLevel }));
	};

	const onChangeDistance = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedDistance = e?.target?.value;
		if (filtersState.distance !== selectedDistance) {
			setOptionClickedMPEventObj({
				"Filter Name": "distance",
				"Option clicked": selectedDistance,
				"Option choice": "added",
			});

			setFiltersState((prev) => ({ ...prev, distance: selectedDistance }));
		}
		if (filtersState.distance === selectedDistance) {
			setOptionClickedMPEventObj({
				"Filter Name": "sortBy",
				"Option clicked": selectedDistance,
				"Option choice": "removed",
			});

			setFiltersState((prev) => ({ ...prev, distance: "" }));
		}
	};

	const onChangeSalary = (value) => {
		const salary = SALARY_SCALE[value];

		if (value !== 0) {
			setOptionClickedMPEventObj({
				"Filter Name": "salary",
				"Option clicked": salary,
				"Option choice": "added",
			});
		}
		if (value === 0) {
			setOptionClickedMPEventObj({
				"Filter Name": "salary",
				"Option clicked": 0,
				"Option choice": "removed",
			});
		}
		setFiltersState((prev) => ({
			...prev,
			salary,
		}));
	};

	const handleSalaryScale = (value) => SALARY_SCALE[value];

	const handleSalaryLabel = (sal = undefined) => {
		const label = sal > 0 ? sal : SALARY_SCALE[salarySliderValue];
		if (!label || label === 0) {
			return "₹0";
		}
		if (label < 100000) {
			return `₹${numberWithCommas(label)}`;
		}
		if (label === 100000) {
			return `₹${label / 100000} Lakh`;
		}
		return `₹${label / 100000} Lakhs`;
	};

	const handleExperienceLabel = () => {
		if (filtersState?.min_experience === MIN_EXPERIENCE_DEFAULT_VALUE) return "Any";
		if (Number(filtersState?.min_experience) === 0) return "Fresher";
		return filtersState?.min_experience;
	};

	const onChangeWorkType = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedWorkType = e?.target?.value;
		let updatedWorkTypeFilter = [];

		if (filtersState?.work_type?.includes(selectedWorkType)) {
			updatedWorkTypeFilter = [
				...(filtersState?.work_type?.filter(
					(type) => type !== selectedWorkType
				) || []),
			];
			setOptionClickedMPEventObj({
				"Filter Name": "workType",
				"Option clicked": selectedWorkType,
				"Option choice": "removed",
			});
		} else {
			updatedWorkTypeFilter = [
				...(filtersState?.work_type || []),
				selectedWorkType,
			];
			setOptionClickedMPEventObj({
				"Filter Name": "workType",
				"Option clicked": selectedWorkType,
				"Option choice": "added",
			});
		}
		setFiltersState((prev) => ({ ...prev, work_type: updatedWorkTypeFilter }));
	};

	const onChangeWorkShift = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedWorkShift = e?.target?.value;
		let updatedWorkShiftFilter = [];

		if (filtersState?.work_shift?.includes(selectedWorkShift)) {
			updatedWorkShiftFilter = [
				...(filtersState?.work_shift?.filter(
					(shift) => shift !== selectedWorkShift
				) || []),
			];
			setOptionClickedMPEventObj({
				"Filter Name": "workShift",
				"Option clicked": selectedWorkShift,
				"Option choice": "removed",
			});
		} else {
			updatedWorkShiftFilter = [
				...(filtersState?.work_shift || []),
				selectedWorkShift,
			];
			setOptionClickedMPEventObj({
				"Filter Name": "workShift",
				"Option clicked": selectedWorkShift,
				"Option choice": "added",
			});
		}
		setFiltersState((prev) => ({ ...prev, work_shift: updatedWorkShiftFilter }));
	};
	const onChangeWorkMode = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedWorkMode = e?.target?.value;
		let updatedWorkModeFilter = [];
		if (filtersState?.work_mode?.includes(selectedWorkMode)) {
			updatedWorkModeFilter = [
				...(filtersState?.work_mode?.filter(
					(workMode) => workMode !== selectedWorkMode
				) || []),
			];
			setOptionClickedMPEventObj({
				"Filter Name": "workMode",
				"Option clicked": selectedWorkMode,
				"Option choice": "removed",
			});
		} else {
			updatedWorkModeFilter = [
				...(filtersState?.work_mode || []),
				selectedWorkMode,
			];
			setOptionClickedMPEventObj({
				"Filter Name": "workMode",
				"Option clicked": selectedWorkMode,
				"Option choice": "added",
			});
		}
		setFiltersState((prev) => ({ ...prev, work_mode: updatedWorkModeFilter }));
	};

	const onChangePostedIn = (e: React.ChangeEvent<HTMLInputElement>) => {
		const postedInHours = parseInt(e?.target?.value, 0);
		const posted = POSTED_IN_OPTIONS.find((obj) => obj.value === postedInHours);
		if (filtersState.posted_in !== postedInHours) {
			setOptionClickedMPEventObj({
				"Filter Name": "postedIn",
				"Option clicked": posted?.label,
				"Option choice": "added",
			});
			setFiltersState((prev) => ({ ...prev, posted_in: postedInHours }));
		} else {
			setOptionClickedMPEventObj({
				"Filter Name": "postedIn",
				"Option clicked": posted?.label,
				"Option choice": "removed",
			});
			setFiltersState((prev) => ({ ...prev, posted_in: 0 }));
		}
	};

	const onChangeSortBy = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedSort = e?.target?.value;
		if (filtersState.sort_by !== selectedSort) {
			setOptionClickedMPEventObj({
				"Filter Name": "sortBy",
				"Option clicked": selectedSort,
				"Option choice": "added",
			});

			setFiltersState((prev) => ({ ...prev, sort_by: selectedSort }));
		}
		if (filtersState.sort_by === selectedSort) {
			setOptionClickedMPEventObj({
				"Filter Name": "sortBy",
				"Option clicked": selectedSort,
				"Option choice": "removed",
			});

			setFiltersState((prev) => ({ ...prev, sort_by: "" }));
		}
	};

	const onChangeGender = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedGender = e?.target?.value;
		if (filtersState?.gender !== selectedGender) {
			setOptionClickedMPEventObj({
				"Filter Name": "gender",
				"Option clicked": selectedGender,
				"Option choice": "added",
			});

			setFiltersState((prev) => ({ ...prev, gender: selectedGender }));
		}
		if (filtersState?.gender === selectedGender) {
			setOptionClickedMPEventObj({
				"Filter Name": "gender",
				"Option clicked": selectedGender,
				"Option choice": "removed",
			});

			setFiltersState((prev) => ({ ...prev, gender: "" }));
		}
	};
	const onChangeEnglishLevel = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedEnglishLevel = e?.target?.value;
		if (filtersState.english_level !== selectedEnglishLevel) {
			setOptionClickedMPEventObj({
				"Filter Name": "english_level",
				"Option clicked": selectedEnglishLevel,
				"Option choice": "added",
			});
			setFiltersState((prev) => ({ ...prev, english_level: selectedEnglishLevel }));
		} else {
			setOptionClickedMPEventObj({
				"Filter Name": "english_level",
				"Option clicked": selectedEnglishLevel,
				"Option choice": "removed",
			});
			setFiltersState((prev) => ({ ...prev, english_level: "" }));
		}
	};

	const onChangeDepartment = (departmentId, departmentSlug, departmentName) => {
		const isDepartmentAlreadySelected = filtersState?.department_id?.find(
			(id) => departmentId === id
		);
		let updatedDepartmentList;
		if (isDepartmentAlreadySelected) {
			updatedDepartmentList = filtersState?.department_id?.filter(
				(id) => departmentId !== id
			);
			setOptionClickedMPEventObj({
				"Filter Name": "department",
				"Option clicked": departmentName,
				"Option choice": "removed",
			});
		} else {
			updatedDepartmentList = [...filtersState.department_id, departmentId];
			setOptionClickedMPEventObj({
				"Filter Name": "department",
				"Option clicked": departmentName,
				"Option choice": "added",
			});
		}
		setFiltersState((prev) => ({
			...prev,
			department_id: updatedDepartmentList,
		}));
	};
	const onChangeExperience = (value) => {
		setOptionClickedMPEventObj({
			"Filter Name": "experience",
			"Option clicked": value,
			"Option choice": "added",
		});

		setFiltersState((prev) => ({
			...prev,
			min_experience: value,
		}));
	};
	const onChangeFeatured = () => {
		// Set Mixpanel event
		setOptionClickedMPEventObj({
			"Filter Name": "featured_jobs", // Change to correct filter name if needed
			"Option clicked": !filtersState?.featured_jobs, // Adjust based on the action
		});

		// Update filter state based on checkbox status
		setFiltersState((prev) => ({
			...prev,
			featured_jobs: !filtersState?.featured_jobs, // Set the value to the current checkbox state
		}));
	};
	const experienceLabel = (value) => {
		if (Number(value) === 0) {
			return "Fresher";
		}
		if (value === 1) {
			return `${value} year`;
		}
		return `${value} years`;
	};
	// const { totalJobs, isJobCountLoading } = useGetJobsCount({
	// 	page_size: 15,
	// 	page: 1,
	// 	...sidebarStates?.query,
	// });

	// useEffect(() => {
	// 	if (!isJobCountLoading && optionClickedMPEventObj) {
	// 		const selectedFilters = getSelectedFilters();
	// 		trackOnMixpanel("Job Filter Option Clicked Web", {
	// 			...optionClickedMPEventObj,
	// 			"distinct jobs available": totalJobs,
	// 			"Selected Filters": selectedFilters,
	// 		});
	// 		setOptionClickedMPEventObj(null);
	// 	}
	// }, [isJobCountLoading, sidebarStates, optionClickedMPEventObj]);

	// MP Selected Filter Obj form SidebarState

	// useEffect(() => {
	// 	if (!isJobCountLoading && totalJobs === 0 && isShowFilterSidebar) {
	// 		handleOpenToast({
	// 			heading: "No jobs available. Clear some filters to see jobs",
	// 			type: "error",
	// 		});
	// 		const selectedFilters = getSelectedFilters();
	// 		trackOnMixpanel("Job Filter Panel zero job warning shown Web", {
	// 			"Selected Filters": selectedFilters,
	// 			"No. of selected Filters": sidebarStates?.filterCount,
	// 		});
	// 	}
	// }, [isJobCountLoading, totalJobs, sidebarStates, isShowFilterSidebar]);

	const getFilterCountPerSection = (filter: FilterChoice) => {
		if (filter === FilterChoice.DEPARTMENT) {
			return filtersState?.department_id?.length;
		}

		if (filter === FilterChoice.EDUCATION) {
			return Number(filtersState?.education_level) > 0 ? 1 : 0;
		}

		if (filter === FilterChoice.WORK_MODE) {
			return filtersState?.work_mode?.length;
		}

		if (filter === FilterChoice.EXPERIENCE) {
			return filtersState?.min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE ? 1 : 0;
		}

		if (filter === FilterChoice.SALARY) {
			return filtersState?.salary ? 1 : 0;
		}

		if (filter === FilterChoice.DISTANCE) {
			return filtersState?.distance ? 1 : 0;
		}

		if (filter === FilterChoice.WORK_TYPE) {
			return filtersState?.work_type?.length;
		}

		if (filter === FilterChoice.WORK_SHIFT) {
			return filtersState?.work_shift?.length;
		}

		if (filter === FilterChoice.SORT_BY) {
			return filtersState?.sort_by !== "" ? 1 : 0;
		}

		if (filter === FilterChoice.POSTED_IN) {
			return filtersState?.posted_in > 0 ? 1 : 0;
		}

		if (filter === FilterChoice.GENDER) {
			return filtersState?.gender !== "" ? 1 : 0;
		}
		if (filter === FilterChoice.ENGLISH) {
			return filtersState?.english_level !== "" ? 1 : 0;
		}
		if (filter === FilterChoice.FEATURED) {
			return filtersState?.featured_jobs !== false ? 1 : 0;
		}

		return 0;
	};

	const bottomListItems = useMemo(() => {
		const list = [];
		if (
			!(departmentObject[0].type === "department" && departmentObject[0].id) &&
			filtersState?.department_id?.length > 0 &&
			filtersState?.department_id?.[0] !== -1
		) {
			filtersState?.department_id?.forEach((selectedDepartment) => {
				const departmentObject = departmentData?.find(
					(d) => d.id === selectedDepartment
				);
				list.push({
					label: departmentObject?.name,
					onDelete: () =>
						onChangeDepartment(
							departmentObject?.id,
							departmentObject?.slug,
							departmentObject?.name
						),
				});
			});
		}
		if (Number(filtersState?.salary) > 0) {
			list.push({
				label: `${handleSalaryLabel()}`,
				onDelete: () => {
					onChangeSalary("");
					setSalarySliderValue(0);
				},
			});
		}
		if (filtersState?.min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE) {
			list.push({
				label: `${experienceLabel(filtersState?.min_experience)}`,
				onDelete: () => onChangeExperience(MIN_EXPERIENCE_DEFAULT_VALUE),
			});
		}

		if (Number(filtersState?.education_level) > 0) {
			const educationItem = EDUCATION_OPTIONS.find(
				({ value }) => value === Number(filtersState?.education_level)
			);
			list.push({
				label: educationItem?.label,
				onDelete: () => onChangeEducation(null),
			});
		}
		if (
			Array.isArray(filtersState?.work_mode) &&
			filtersState?.work_mode?.length > 0
		) {
			filtersState?.work_mode?.forEach((selectedWorkMode) => {
				const workModeItem = WORK_MODE_OPTIONS.find(
					({ value }) => value === selectedWorkMode
				);
				list.push({
					label: workModeItem?.label,
					onDelete: () =>
						onChangeWorkMode({
							target: { value: workModeItem?.value },
						} as unknown as React.ChangeEvent<HTMLInputElement>),
				});
			});
		}
		if (
			Array.isArray(filtersState?.work_type) &&
			filtersState?.work_type?.length > 0
		) {
			filtersState?.work_type?.forEach((selectedWorkType) => {
				const workTypeItem = WORK_TYPE_OPTIONS.find(
					({ value }) => value === selectedWorkType
				);
				list.push({
					label: workTypeItem?.label,
					onDelete: () =>
						onChangeWorkType({
							target: { value: workTypeItem?.value },
						} as unknown as React.ChangeEvent<HTMLInputElement>),
				});
			});
		}
		if (
			Array.isArray(filtersState?.work_shift) &&
			filtersState?.work_shift?.length > 0
		) {
			filtersState?.work_shift?.forEach((selectedWorkShift) => {
				const workShiftItem = WORK_SHIFT_OPTIONS.find(
					({ value }) => value === selectedWorkShift
				);
				list.push({
					label: workShiftItem?.label,
					onDelete: () =>
						onChangeWorkShift({
							target: { value: workShiftItem?.value },
						} as unknown as React.ChangeEvent<HTMLInputElement>),
				});
			});
		}
		if (filtersState?.posted_in > 0) {
			const selectedPostedInItem = POSTED_IN_OPTIONS.find(
				({ value }) => value === filtersState?.posted_in
			);
			list.push({
				label: `Posted in - ${selectedPostedInItem?.label}`,
				onDelete: () =>
					onChangePostedIn({
						target: { value: selectedPostedInItem?.value },
					} as unknown as React.ChangeEvent<HTMLInputElement>),
			});
		}
		if (filtersState?.sort_by !== "" && discoveryTabs.activeTabId !== 2) {
			const selectedSortBy = SORT_BY_OPTIONS.find(
				({ value }) => value === filtersState?.sort_by
			);
			list.push({
				label: `Sort by - ${selectedSortBy?.label}`,
				onDelete: () =>
					onChangeSortBy({
						target: { value: selectedSortBy?.value },
					} as unknown as React.ChangeEvent<HTMLInputElement>),
			});
		}
		if (filtersState?.gender !== "" && !urlDataObject?.path?.gender) {
			const selectedGender = GENDER_OPTIONS.find(
				({ value }) => value === filtersState?.gender
			);
			list.push({
				label: selectedGender?.label,
				onDelete: () =>
					onChangeGender({
						target: { value: selectedGender?.value },
					} as unknown as React.ChangeEvent<HTMLInputElement>),
			});
		}
		if (filtersState?.english_level !== "") {
			const selectedEnglishLevel = ENGLISH_LEVEL_OPTIONS.find(
				({ value }) => value === filtersState?.english_level
			);
			list.push({
				label: selectedEnglishLevel?.label,
				onDelete: () =>
					onChangeEnglishLevel({
						target: { value: selectedEnglishLevel?.value },
					} as unknown as React.ChangeEvent<HTMLInputElement>),
			});
		}
		if (filtersState?.distance) {
			const selectedDistance = DISTANCE_OPTIONS.find(
				({ value }) => value === filtersState?.distance
			);
			list.push({
				label: selectedDistance?.label,
				onDelete: () =>
					onChangeDistance({
						target: { value: selectedDistance?.value },
					} as unknown as React.ChangeEvent<HTMLInputElement>),
			});
		}
		if (filtersState?.featured_jobs) {
			list.push({
				label: "Featured jobs",
				onDelete: () => onChangeFeatured(),
			});
		}
		return list;
	}, [
		filtersState,
		onChangeDepartment,
		onChangeEducation,
		onChangeWorkMode,
		onChangeWorkShift,
		onChangeWorkType,
		onChangePostedIn,
		onChangeSortBy,
		onChangeGender,
		onChangeDistance,
		discoveryTabs,
	]);
	// eslint-disable-next-line consistent-return
	const showOptions = () => {
		if (
			activeFilterChoice === FilterChoice.DEPARTMENT &&
			!urlDataObject?.path?.department_id
		) {
			const filteredDepartmentList = filterDepartments(departmentData, searchQuery);
			if (!filteredDepartmentList?.length && !filterWithNoRelevantSearch) {
				setFilterWithNoRelevantSearch("Department");
			} else if (filteredDepartmentList?.length && filterWithNoRelevantSearch) {
				setFilterWithNoRelevantSearch("");
			}
			return (
				<OptionsContainer>
					<SearchBar
						searchQuery={searchQuery}
						setSearchQuery={setSearchQuery}
						placeholder="Search department"
						showCloseIcon
					/>
					{!filteredDepartmentList?.length && (
						<EmptySearchView
							searchSource="department"
							isDesktopView={isDesktopView}
						/>
					)}
					{filteredDepartmentList.map((department) => (
						<CheckboxInput
							key={department.id}
							label={department?.name}
							name="department"
							isRadioButton={false}
							value={department?.id}
							onChange={() => {
								onChangeDepartment(
									department?.id,
									department?.slug,
									department?.name
								);
							}}
							checked={filtersState?.department_id?.find(
								(id) => department.id === id
							)}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (
			!urlDataObject?.path?.work_mode &&
			activeFilterChoice === FilterChoice.WORK_MODE
		) {
			return (
				<OptionsContainer>
					{WORK_MODE_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							isRadioButton={false}
							name="work_mode"
							value={item.value}
							onChange={onChangeWorkMode}
							checked={filtersState?.work_mode?.includes(item.value)}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (
			!urlDataObject?.path?.work_type &&
			activeFilterChoice === FilterChoice.WORK_TYPE
		) {
			return (
				<OptionsContainer>
					{WORK_TYPE_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							isRadioButton={false}
							name="work_type"
							value={item.value}
							onChange={onChangeWorkType}
							checked={filtersState?.work_type?.includes(item.value)}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (
			!urlDataObject?.path?.work_shift &&
			activeFilterChoice === FilterChoice.WORK_SHIFT
		) {
			return (
				<OptionsContainer>
					{WORK_SHIFT_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							isRadioButton={false}
							name="work_shift"
							value={item.value}
							onChange={onChangeWorkShift}
							checked={filtersState?.work_shift?.includes(item.value)}
						/>
					))}
				</OptionsContainer>
			);
		}

		if (activeFilterChoice === FilterChoice.SORT_BY) {
			if (discoveryTabs.activeTabId === 2) {
				return null;
			}
			return (
				<OptionsContainer>
					{SORT_BY_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							name="sort_by"
							value={item.value}
							onChange={onChangeSortBy}
							checked={
								filtersState?.sort_by !== ""
									? item.value === filtersState?.sort_by
									: item.value === ""
							}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (activeFilterChoice === FilterChoice.EDUCATION) {
			return (
				<OptionsContainer>
					<p className="mb-[16px] mt-[24px] text-[12px] text-[#8C8594]">
						Select your highest education level to see all eligible jobs
					</p>
					{EDUCATION_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							name="education"
							value={item.value}
							onChange={onChangeEducation}
							checked={item.value === Number(filtersState?.education_level)}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (activeFilterChoice === FilterChoice.FEATURED) {
			return (
				<OptionsContainer>
					<CheckboxInput
						key="featured_jobs_checkbox"
						label="Featured jobs"
						name="featured_jobs"
						value={filtersState?.featured_jobs}
						onChange={onChangeFeatured} // The updated handler
						checked={filtersState?.featured_jobs}
					/>
				</OptionsContainer>
			);
		}
		/* 
		Show distance filter options based on feed and search  
		    FEED - only render when user is logged in and onboarded
		    SEARCH - only redner when search location query is non empty and of type "area"
		*/

		if (
			activeFilterChoice === FilterChoice.DISTANCE &&
			((!isSearch && isUserLoggedIn() && isOnboardingComplete()) ||
				(isSearch &&
					(router.query?.location_type === "NBArea" ||
						router.query?.location_type === "Area") &&
					router.query?.location_name !== ""))
		) {
			return (
				<OptionsContainer>
					{DISTANCE_OPTIONS.filter((item) =>
						discoveryTabs.activeTabId === 3
							? item.value !== "lt-20" && item.value !== "lt-50"
							: true
					).map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							name="distance"
							value={item.value}
							onChange={onChangeDistance}
							checked={item.value === filtersState?.distance}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (activeFilterChoice === FilterChoice.SALARY) {
			return (
				<OptionsContainer>
					<div className="mt-[8px]">
						<p className="relative z-10 mb-[16px] mt-[24px] text-[12px] text-[#8C8594]">
							Minimum monthly salary
						</p>
						<CustomSlider
							step={1}
							value={salarySliderValue}
							min={0}
							max={15}
							valueLabelDisplay="on"
							ValueLabelComponent={CustomValueLabel}
							onChange={(_, value) => setSalarySliderValue(value as number)}
							onChangeCommitted={(_, value) => {
								onChangeSalary(value);
							}}
							valueLabelFormat={handleSalaryLabel()}
							scale={handleSalaryScale}
						/>
					</div>
				</OptionsContainer>
			);
		}

		if (activeFilterChoice === FilterChoice.POSTED_IN) {
			return (
				<OptionsContainer>
					{POSTED_IN_OPTIONS.filter((item) =>
						discoveryTabs.activeTabId === 4
							? item.label !== "Last 7 days"
							: true
					).map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							name="postedIn"
							value={item.value}
							onChange={onChangePostedIn}
							checked={filtersState?.posted_in === item.value}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (activeFilterChoice === FilterChoice.EXPERIENCE) {
			return (
				<OptionsContainer>
					<div className="mt-[8px]">
						<InputSlider
							isDesktopView={isDesktopView}
							heading="Your work experience"
							minValue={0}
							maxValue={MIN_EXPERIENCE_DEFAULT_VALUE}
							startMark="0 years"
							endMark="31 years"
							value={filtersState?.min_experience}
							onChange={(_, v) => {
								onChangeExperience(v);
							}}
							handleValueLabelFormat={handleExperienceLabel}
						/>
					</div>
				</OptionsContainer>
			);
		}
		if (activeFilterChoice === FilterChoice.GENDER) {
			return (
				<OptionsContainer>
					{GENDER_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							name="gender"
							isRadioButton
							value={item.value}
							onChange={onChangeGender}
							checked={item.value === filtersState?.gender}
						/>
					))}
				</OptionsContainer>
			);
		}
		if (activeFilterChoice === FilterChoice.ENGLISH) {
			return (
				<OptionsContainer>
					<p className="mb-[16px] mt-[24px] text-[12px] text-[#8C8594]">
						Select your English level to see all eligible jobs
					</p>
					{ENGLISH_LEVEL_OPTIONS.map((item) => (
						<CheckboxInput
							key={item.label}
							label={item.label}
							name="english_level"
							isRadioButton
							value={item.value}
							onChange={onChangeEnglishLevel}
							checked={item.value === filtersState?.english_level}
						/>
					))}
				</OptionsContainer>
			);
		}
	};

	const getQueryObj = () => {
		const queryObj: any = {};
		const routerQueries = router.query;
		if (isUserLoggedIn()) {
			queryObj.c_id = isUserLoggedIn();
		}
		if (routerQueries?.city_id) {
			queryObj.city_id = routerQueries?.city_id;
		}
		if (routerQueries?.area_id) {
			queryObj.area_id = routerQueries?.area_id;
		}
		if (routerQueries?.entity_type) {
			queryObj.entity_type = routerQueries?.entity_type;
		}
		if (routerQueries?.entity_id) {
			queryObj.entity_id = routerQueries?.entity_id;
		}
		if (routerQueries?.text) {
			queryObj.text = routerQueries?.text;
		}
		if (routerQueries?.search) {
			queryObj.search = routerQueries?.search;
		}
		if (routerQueries?.location_id) {
			queryObj.location_id = routerQueries?.location_id;
		}
		if (routerQueries?.location_identifier) {
			queryObj.location_identifier = routerQueries?.location_identifier;
		}
		if (routerQueries?.location_type) {
			queryObj.location_type = routerQueries?.location_type;
		}
		if (routerQueries?.location_name) {
			queryObj.location_name = routerQueries?.location_name;
		}

		return queryObj;
	};
	const applyFilters = () => {
		if (
			filtersState.min_experience > 0 &&
			filtersState.min_experience < MIN_EXPERIENCE_DEFAULT_VALUE
		) {
			setExperienceSearchObject({
				display_text:
					VALUE_TO_LABEL_MAPPING?.min_experience?.[filtersState.min_experience],
				experience_input: filtersState.min_experience,
			});
		}
		applyMobileFilters(filtersState);
	};

	const shouldHideDistanceFilter = (label) => {
		/* 
			Hide Distance filter based on feed and search  
				FEED - when user is not logged in or not onboarded / partial
				SEARCH - when search location query is empty or of type other than "area"
		*/
		if (label !== "Distance") return false;

		const isSearchInvalidLocationType =
			isSearch &&
			router.query?.location_type !== "NBArea" &&
			router.query?.location_type !== "Area";

		const isSearchEmptyLocationName = isSearch && router.query?.location_name === "";

		const isFeedUserNotEligible =
			!isSearch && (!isUserLoggedIn() || !isOnboardingComplete());

		return (
			isSearchInvalidLocationType ||
			isSearchEmptyLocationName ||
			isFeedUserNotEligible
		);
	};

	return (
		<Drawer
			open={isShowFilterSidebar}
			onClose={() => {
				closeSidebar();
				setSalarySliderValue(
					getKeyByValue(SALARY_SCALE, Number(appliedFilters?.salary))
				);

				setFiltersState(appliedFilters);
			}}
			anchor="bottom"
			classes={{
				paper: classes.drawer,
			}}
		>
			<div className="bg-transparent">
				<div
					className=" flex items-center justify-end p-[16px]"
					onClick={() => {
						closeSidebar();
						setSalarySliderValue(
							getKeyByValue(SALARY_SCALE, Number(appliedFilters?.salary))
						);

						setFiltersState(appliedFilters);
					}}
				>
					<button type="button" aria-label="Close">
						<CrossWithBGIcon />
					</button>
				</div>
				<MobileContainer onClick={(event) => event.stopPropagation()}>
					<FiltersContainer isBottomListItems={!!bottomListItems?.length}>
						<ChoicesContainer>
							{Object.entries(FILTER_LABELS_LIST).map(
								([filterType, label]) => {
									if (
										(label === FILTER_LABELS.department &&
											Array.isArray(departmentObject) &&
											departmentObject.length > 0 &&
											departmentObject[0]?.type === "department" &&
											departmentObject[0]?.id) ||
										shouldHideDistanceFilter(label) ||
										(label === FILTER_LABELS.gender &&
											urlDataObject?.path &&
											urlDataObject?.path?.gender) ||
										(label ===
											FILTER_LABELS[FilterChoice.WORK_MODE] &&
											urlDataObject?.path &&
											urlDataObject?.path?.work_mode) ||
										(label ===
											FILTER_LABELS[FilterChoice.WORK_SHIFT] &&
											urlDataObject?.path &&
											urlDataObject?.path?.work_shift) ||
										(label ===
											FILTER_LABELS[FilterChoice.WORK_TYPE] &&
											urlDataObject?.path &&
											urlDataObject?.path?.work_type) ||
										(label === FILTER_LABELS.featured &&
											!showFeaturedFilter) ||
										(filterType === FilterChoice.SORT_BY &&
											discoveryTabs.activeTabId === 2)
									)
										return <></>;
									return (
										<Choice
											onClick={() => {
												setActiveFilterChoice(
													filterType as FilterChoice
												);
											}}
											isActive={activeFilterChoice === filterType}
											key={label}
										>
											<span>{label}</span>
											{getFilterCountPerSection(
												filterType as FilterChoice
											) > 0 && (
												<span className="text-[12px] font-[400] text-[#8C8594]">
													{getFilterCountPerSection(
														filterType as FilterChoice
													)}
												</span>
											)}
										</Choice>
									);
								}
							)}
						</ChoicesContainer>

						{showOptions()}
					</FiltersContainer>
					<FooterContainer>
						{!!bottomListItems?.length && (
							<SelectChipsContainer options={bottomListItems} />
						)}
						{/* <StatsBar>
						<Text>{sidebarStates?.filterCount || 0} filter(s) applied</Text>
						<Separator>●</Separator>
						<Text>
							{isJobCountLoading ? (
								<CircularProgress
									size={12}
									color="inherit"
									style={{ marginRight: "4px" }}
								/>
							) : (
								`${totalJobs}`
							)}{" "}
							job(s) available
						</Text>
					</StatsBar> */}
						<Footer>
							<ClearButton
								variant="primary"
								link
								size="small"
								onClick={() => {
									setExperienceSearchObject({});
									setFiltersState(initialFilterStates);
									setUrlSearchQuery(getQueryObj());
									setSalarySliderValue(0);
									setClearTabsAppliedFilters(true);
								}}
							>
								Clear Filters
							</ClearButton>
							<ApplyButton
								variant="primary"
								onClick={() => {
									trackOnMixpanel("Jobs Filtered Web", {
										"Selected Filters":
											getSelectedFiltersList(filtersState),
										Source: "Job Listing Page",
										"No. of selected Filters": appliedFiltersCount,
										"Distinct Jobs Shown": jobsCount,
									});
									if (clearTabsAppliedFilters) {
										clearAllFilters();
										setClearTabsAppliedFilters(false);
									}
									applyFilters();
									closeSidebar();
								}}
							>
								Apply
							</ApplyButton>
						</Footer>
					</FooterContainer>
				</MobileContainer>
			</div>
		</Drawer>
	);
};

export default FiltersSidebar;
